import React from 'react';
import ControlPlaneLayout from './ControlPlaneLayout';

const SettlementPage = () => {
  return (
    <ControlPlaneLayout
      eyebrow="Settlement Page"
      title="Settlement ledger"
      description="Inspect holds, early releases, refunds, and final outcome-linked payouts across all active request markets."
    />
  );
};

export default SettlementPage;
